'use client';

import { RevealingPointsComponent } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import styles from './RevealingPoints.module.scss';
import RevealingPoint from './RevealingPoint';
import { ButtonVariants } from '../Button';
import RevealingPointsButton, { IRevealingPointsButtonProps } from './RevealingPointsButton';

export default function RevealingPoints({
  data,
  actionButtonText,
  actionButtonVariant = ButtonVariants.OUTLINED,
  contactFormType = 'modal',
}: {
  data: RevealingPointsComponent;
  actionButtonText: string;
  actionButtonVariant?: ButtonVariants;
  contactFormType?: IRevealingPointsButtonProps['contactFormType'];
}) {
  return (
    <section className={classNames(styles.revealingPointsSection, 'container')}>
      <div className={styles.headBlock}>
        <div className={styles.descriptionBlock}>
          <h2 className={classNames(styles.title, 'header2')}>{data.title}</h2>
          {!!data.description && <p className={styles.description}>{data.description}</p>}
        </div>
        <RevealingPointsButton
          contactFormType={contactFormType}
          actionButtonVariant={actionButtonVariant}
          text={data.ctaButton || actionButtonText}
        />
      </div>
      <div className={styles.items}>
        {data.points.map(item => (
          <RevealingPoint
            key={item.id}
            item={item}
          />
        ))}
      </div>
    </section>
  );
}
